module.exports = __webpack_public_path__ + "img/img3.17669218.png";